export default "__VITE_ASSET__fccc3728__"